module.exports = __webpack_public_path__ + "static/media/atmajaya_jakarta.e84cf427.png";